import { Environment, generateApi } from '@environment';

import { environment as baseEnvironment } from './environment.all';

const environmentOverrides: Partial<Environment> = {
  mode: 'prod',

  useProductionData: true,

  api: generateApi({
    url: 'https://api.usheru.com/rest',
    ushChannel: '0763d4a6-d341-4eea-98aa-3c7b475f0552',
    user: 'acontracorriente-api@noemail.com',
    pass: 'cK76mwthLEJgg2h',
    versionOverrides: {
      v2: ['movies/in-cinemas/', 'movies/watch-at-home/', 'movies/', 'channels/channel-videos/']
    }
  }),

  google: {
    maps_key: 'AIzaSyDZUidGlbVTCPiX2iDQY8x1X_SaYZbenr8'
  }
};

export const environment: Environment = Object.assign({}, baseEnvironment, environmentOverrides);
